<template>
  <div class="WriteMessagePopup" v-if="showPopup">
    <div class="PopUpWriteMessage">
      <div class="PopUpFon" @click="hidePopup()"></div>
      <div class="PopUpComPanel">
        <div class="PopUpComBlock">
          <div class="AuthorBlock">
            <div class="MAva" :style='{ backgroundImage: `url(${user.avatar_preview_40})` }'></div>
            <div class="Redactor">{{ user.name }}</div>
          </div>
          <div class="PopUpClose" @click="hidePopup()"></div>
          <div class="Razdelitel"></div>

          <div class="WriteMessageForm" v-if="authorized">
            <form @submit.prevent="sendMessage">
              <textarea maxlength='250' placeholder="Сообщение" v-model="messageText"></textarea>
              <input type="submit" class="SendMessage" value="Отправить" />
            </form>
          </div>
          <div v-if="!authorized">
            Необходимо авторизоваться, чтобы оставить комментарий.
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isEmpty } from 'lodash';
import { mapGetters } from 'vuex';
import { API_ROOT } from "@/utils/api_root";

export default {
  data() {
    return {
      messageText: null
    };
  },
  computed: {
    ...mapGetters(['currentUser', 'authorized']),
    showPopup() {
      return this.$store.state.showWriteMessagePopup;
    },
    user() {
      return this.$store.state.writeMessageUser;
    }
  },
  methods: {
    hidePopup() {
      this.$store.commit('onHideWriteMessagePopup');
    },
    sendMessage() {
      console.log('sendMessage', this.messageText);
      if (isEmpty(this.messageText)) return;
      const params = { message: this.messageText,
                       recipient_id: this.user.id }
      console.log('sendMessage params', params);

      this.$http.post(`${API_ROOT}/private_messages`, {message: params})
        .then(response => {
          console.log('sendMessage success', response, response.data);
          this.messageText = null;
          this.flash('Сообщение отправлено', 'success', {timeout: 3000});
          this.$store.commit('onHideWriteMessagePopup');
        })
        .catch(error => {
          console.log('sendMessage error', error, error.response.data);
          this.flash('Ошибка отправки сообщения', 'error');
        });
    },
  },
};
</script>

<style>
.WriteMessagePopup{
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  /* background-color: #323938;
  border-top: 1px solid #ccc; */
  z-index: 10;
}

.PopUpComments{
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 10;
}

.WriteMessageForm{
  position: relative;
  left: 40px;
  padding: 10px;
  margin-top: 30px;
  width: 500px;
  font-family: 'Open Sans', sans-serif;
  color: #666;
  font-size: 16px;
  border: 1px solid #b1b1b1;
  border-radius: 5px;
  background-color: #fff;
}
</style>
